import type { Bar } from 'charting_library';
import type { CandleSeries } from '@/api/spec.ts';
import useAppStore from '../../../store/rootStore.ts';
import { offsetNumberToNumber } from '@/utils/tokenNumberUtils.ts';
import { amountToBig } from '@/utils/bigUtils.ts';

export function mapCandleSeriesToBars(candleSeries: CandleSeries, marketId: string): Bar[] {
  const market = useAppStore.getState().markets.get(Number(marketId));
  if (!market) {
    return [];
  }
  const displayDecimals = market.quoteDecimals;
  const tokenDecimals = market.quote.decimals;

  const candles = candleSeries.d || [];
  return candles
    .filter((candle) => !(candle.o === 0 && candle.c === 0 && candle.h === 0 && candle.l === 0))
    .map((candle) => ({
      time: candle.t,
      open: offsetNumberToNumber(candle.o, displayDecimals),
      close: offsetNumberToNumber(candle.c, displayDecimals),
      high: offsetNumberToNumber(candle.h, displayDecimals),
      low: offsetNumberToNumber(candle.l, displayDecimals),
      volume: amountToBig(candle.v || '0', tokenDecimals).toNumber(),
    }));
}
